export const GetAxiosAuthConfig = {
    data() {
        return {
            axios_auth_config: {}
        }
    },
    created() {
        this.SetConfig()
    },
    methods: {
        SetConfig() {
            // create config dict to pass auth headers to axios
            let config = {
                headers: {
                    Authorization: 'token ' + localStorage.getItem('den_vueauth_token'),
                }
            }
            self.axios_auth_config = config
        }
    },
}
